const logDeprecationWarning = (message)=>{
    // eslint-disable-next-line no-console
    console.warn(`⚠️ [uploadthing][deprecated] ${message}`);
};

export { logDeprecationWarning };
